const PrivacyPolicy = () => (
  <>
    <p>
      코드앤버터는 개인정보보호법에 따라 이용자의 개인정보 및 권익을 보호하고
      개인정보와 관련한 이용자의 고충을 원할하게 처리할 수 있도록 다음과 같은
      처리 방침을 두고 있습니다.
    </p>
    <h2 id="-1-">1. 수집하는 개인정보 항목</h2>
    <p>
      코드앤버터는 회원가입 의사 확인, 회원제 서비스에 따른 회원 자격 인증 및
      식별, 회원 자격 유지 관리, 웹사이트 서비스의 정상적 제공, 서비스 부정이용
      방지, 분쟁 조정을 위한 기록 보존 등을 위해 아래와 같은 개인정보를 수집하고
      있습니다.
    </p>
    <h3>1.1. 수집항목</h3>
    <p>
      <table className="privacy-policy-table">
        <tr>
          <th>처리목적</th>
          <th>수집항목</th>
        </tr>
        <tr>
          <td>
            <ul>
              <li>회원 가입 및 관리</li>
              <li>이용자 식별</li>
              <li>서비스 제공 및 관리(세금계산서 발행 포함)</li>
              <li>서비스 관련 고지 및 문의사항 처리</li>
              <li>마케팅 정보 제공</li>
            </ul>
          </td>
          <td>
            [필수]이름(닉네임), 이메일, 비밀번호, 휴대폰 번호, 회사명, 업종,
            유입 경로
            <br />
            [선택] 직무, 서비스명, 직원 수, 쿠키, 서비스 이용기록, (세금계산서
            발행시) 담당자 정보(이름, 연락처, 이메일주소), (세금계산서 발행시)
            전자세금계산서 발급용 이메일주소
          </td>
        </tr>
        <tr>
          <td>
            <ul>
              <li>이용료 결제 및 환불</li>
            </ul>
          </td>
          <td>
            신용카드 결제 시: 카드사명, 카드번호, 유효기간, 카드 비밀번호 앞
            2자리, 보유자 생년월일
            <br />
            계좌이체 시: 예금주명, 은행명, 계좌번호
          </td>
        </tr>
        <tr>
          <td>
            <ul>
              <li>&lt;파트너스 제도 대금 정산 발생 시&gt; 대금 지급</li>
            </ul>
          </td>
          <td>
            이름, 계좌정보(예금주명, 은행명, 계좌번호) 주민등록번호 (소득세 등
            세금 관련 법령에 따름)
          </td>
        </tr>
      </table>
    </p>

    <h3>1.2. 개인정보 수집방법</h3>
    <ul>
      <li>회원가입 시 또는 [마이페이지]에서 직접 입력</li>
      <li>서비스 이용 중 입력 또는 자동 수집</li>
      <li>문의하기 기능 사용 시 직접 입력</li>
    </ul>
    <h3>1.3. 소셜 로그인</h3>
    <p>
      회사는 고객님의 선택에 따라 소셜 로그인(이하 “OAuth“라고 함)을 사용할 수
      있도록 하고 있습니다. OAuth 서비스 제공자의 OAuth 서비스를 이용하고자 할
      경우 다음의 필수 정보를 입력하여야 합니다.
    </p>
    <ul>
      <li>
        이메일: OAuth를 제공하는 서비스에 등록되고 접근이 허락된 사용자 이메일
      </li>
    </ul>
    <p>
      또한, OAuth 서비스 제공자의 OAuth 서비스 이용 시 고객님의 데이터에
      액세스하고 서비스에 사용할 수 있습니다. OAuth 서비스 이용 과정에서
      자동생성 되어 저장되는 정보는 아래와 같습니다.
    </p>
    <ul>
      <li>OAuth 서비스 제공자에게 전달받은 Token 정보</li>
    </ul>

    <p>
      회사는 OAuth 서비스를 이용하여 제공받은 데이터나 개인정보를 저장하지
      않습니다. OAuth 서비스의 이용을 원치 않는 경우 언제든지 연결 해제 버튼을
      클릭하여 연결을 해제할 수 있으며, 이 경우 저장되어 있던 Token 정보는
      삭제됩니다.
    </p>
    <h2 id="-2-">2. 개인정보의 수집 및 이용목적</h2>
    <p>
      회사는 수집한 개인정보를 다음과 같은 목적으로만 활용합니다. 차후
      이용목적이 변경될 시에는 사전에 동의를 구합니다.
    </p>
    <ul>
      <li>
        회원관리 측면에서 가입 의사 확인, 불만처리 등 민원 처리, 고지사항 전달,
        서비스 이용에 따른 본인식별, 중복가입 확인, 부정이용 방지 시 사용됩니다.
      </li>
      <li>
        서비스 내에 회원정보를 표시할 경우, 예를 들어 고객님이 생성한 팀,
        캠페인, 혹은 기타 활동 기록을 표시할 때 고객님의 프로필(이메일, 프로필
        사진 등)이 표시될 수 있습니다.
      </li>
      <li>
        마케팅 활동을 위한 이벤트 정보를 전달하거나, 고객님의 접속 빈도 또는
        서비스 이용 통계를 분석할 때 사용됩니다.
      </li>
    </ul>

    <h2 id="-3-">3. 개인정보의 보유 및 이용기간</h2>
    <p>
      코드앤버터는 회원가입일로부터 서비스를 제공하는 기간 동안에 한하여
      이용자의 개인정보를 보유 및 이용합니다.
    </p>
    <p>
      <table className="privacy-policy-table">
        <tr>
          <th>보존항목</th>
          <th>근거법령</th>
          <th>보유기간</th>
        </tr>
        <tr>
          <td>계약 또는 청약철회 등에 관한 기록</td>
          <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
          <td>5년</td>
        </tr>
        <tr>
          <td>대금결제 및 재화 등의 공급에 관한 기록</td>
          <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
          <td>5년</td>
        </tr>
        <tr>
          <td>표시/광고에 관한 기록</td>
          <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
          <td>6개월</td>
        </tr>
        <tr>
          <td>사용자의 불만 또는 분쟁처리 기록</td>
          <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
          <td>3년</td>
        </tr>
        <tr>
          <td>세법이 규정하는 모든 거래에 관한 장부 및 증빙서류</td>
          <td>국세기본법</td>
          <td>5년</td>
        </tr>
        <tr>
          <td>전자금융 거래에 관한 기록</td>
          <td>전자금융거래법</td>
          <td>5년</td>
        </tr>
        <tr>
          <td>서비스 방문기록</td>
          <td>통신비밀보호법</td>
          <td>3개월</td>
        </tr>
        <tr>
          <td>장부, 세금계산서, 영수증 등 기록</td>
          <td>부가가치세법</td>
          <td>5년</td>
        </tr>
        <tr>
          <td>
            &lt;파트너스 제도 대상&gt;
            <br />
            계좌정보(예금주명, 은행명, 계좌번호), 통장 사본
          </td>
          <td>국세기본법, 법인세법, 부가가치세법</td>
          <td>5년</td>
        </tr>
        <tr>
          <td>
            &lt;파트너스 제도 대상&gt;
            <br />
            주민등록번호
          </td>
          <td>국세기본법, 법인세법, 부가가치세법</td>
          <td>5년</td>
        </tr>
      </table>
    </p>

    <h2 id="-4-">4. 개인정보의 제3자 제공</h2>
    <ol>
      <li>
        회사는 정보주체의 개인정보를 제1조에서 명시한 범위 내에서만 처리하며,
        정보주체의 동의, 법률의 특별한 규정 등 「개인정보보호법」제17조 및
        제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
      </li>
      <li>
        회사는 타 법령에 특별한 규정이 있는 경우를 제외하고, 개인정보를 고지
        또는 명시한 범위를 초과하여 이용하거나 제3자에게 제공하지 않습니다.
      </li>
    </ol>

    <h2 id="-5-">5. 개인정보의 파기절차 및 방법</h2>
    <p>
      원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이
      파기합니다. 파기절차 및 방법은 다음과 같습니다.
    </p>

    <p>
      회원이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 내부 방침 및
      기타 관련 법령에 의한 정보보호 사유에 따라 일정 기간 저장된 후 파기됩니다.
    </p>
    <p>
      일정기간 저장된 개인정보는 법률에 의한 경우가 아니고서는 보유 이외의 다른
      목적으로 이용되지 않습니다.
    </p>
    <h3>5.2. 파기방법</h3>
    <p>
      전자적 파일형태로 저장된 개인정보는 파일 형태의 경우 파일 삭제를,
      데이터베이스 데이터의 경우 테이블 혹은 레코드 값 삭제를 이용해 파기합니다.
    </p>
    <h2 id="-6-">6. 개인정보 제공</h2>
    <p>
      코드앤버터는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다.
      다만, 아래의 경우에는 예외로 합니다.
    </p>
    <ul>
      <li>이용자들이 사전에 동의한 경우</li>
      <li>
        법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라
        수사기관의 요구가 있는 경우
      </li>
    </ul>
    <h2 id="-7-">7. 수집한 개인정보의 위탁</h2>
    <p>
      코드앤버터는 서비스 향상을 위해 아래와 같이 이용자의 개인정보를 위탁하고
      있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록
      필요한 사항을 규정하고 있습니다.
    </p>
    <p>
      <table className="privacy-policy-table">
        <tr>
          <th>수탁 업체</th>
          <th>위탁업무 내용</th>
          <th>개인정보 보유 및 이용기간</th>
        </tr>
        <tr>
          <td>스티비 주식회사</td>
          <td>광고 등 이메일 마케팅 발송 서비스</td>
          <td>회원 탈퇴시, 서비스 종료시 혹은 위탁 계약 종료시까지</td>
        </tr>
        <tr>
          <td>Amazon Web Services Inc.</td>
          <td>개인정보 처리를 위한 인프라 관리&#40;한국 리전&#41;</td>
          <td>회원 탈퇴시, 서비스 종료시 혹은 위탁 계약 종료시까지</td>
        </tr>
        <tr>
          <td>주식회사 토스페이먼츠</td>
          <td>결제수단 인증 및 결제처리</td>
          <td>회원 탈퇴시, 서비스 종료시 또는 위탁 계약 종료시까지</td>
        </tr>
      </table>
    </p>
    <p>
      코드앤버터는 다음과 같이 개인정보 처리 업무 중 일부를 국외 사업자에게
      이전하고 있습니다.
      <ul>
        <li>수탁 업체: Google Analytics</li>
        <li>이전되는 국가: 미국</li>
        <li>정보관리책임자의 연락처: googlekrsupport@google.com</li>
        <li>이전 시점과 방법: 서비스 이용 시점에 네트워크를 통해 전송</li>
        <li>이용 항목: 쿠키, 서비스 이용 기록 등</li>
        <li>이용 목적: 사용 현황 분석, 사용자 데이터 분석</li>
        <li>이용 기간: 회원 탈퇴시, 서비스 종료시 혹은 위탁 계약 종료시까지</li>
      </ul>
    </p>
    <p>
      코드앤버터는 그 밖에 추가적으로 제3자에게 개인정보를 처리, 위탁 해야 하는
      경우에 본 개인정보처리방침을 통하여 이를 공개하겠습니다.
    </p>
    <h2 id="-8-">8. 이용자 및 법정대리인의 권리와 그 행사방법</h2>
    <p>
      이용자 및 법정 대리인은 언제든지 등록되어 있는 자신의 개인정보를
      조회하거나 수정할 수 있으며 회원 탈퇴를 요청할 수 있습니다.
    </p>
    <p>
      이용자의 개인정보 조회/수정을 위해서는 수정 기능을, 회원 탈퇴를 위해서는
      회원정보 수정 페이지의 탈퇴 기능을 이용할 수 있습니다.
    </p>
    <p>
      혹은 코드앤버터 운영진에게 이메일, 게시물, 쪽지 등의 어떤 수단으로든
      연락을 하신다면 수신 후 최대한 빠른 시간 내에 조치하겠습니다.
    </p>
    <p>
      코드앤버터는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된
      개인정보는 “개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그
      외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
    </p>
    <h2 id="-9-">
      9. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항
    </h2>
    <p>
      코드앤버터는 이용자의 정보를 수시로 저장하고 찾아내는 ‘쿠키(Cookie)’ 등을
      사용합니다. 쿠키란 코드앤버터를 운영하는데 이용되는 서버가 귀하의 웹
      브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 웹 브라우저에서
      사용하는 공간에 저장됩니다.
    </p>
    <p>코드앤버터는 다음과 같은 목적을 위해 쿠키를 사용합니다.</p>
    <ul>
      <li>
        이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태 등을
        파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.
      </li>
      <li>
        구글 애널리틱스: 일부 또는 모든 웹사이트에서 구글(Google)이 제공하는
        인터넷 사이트 분석 서비스인 구글 애널리틱스를 사용할 수 있습니다. 구글
        애널리틱스는 귀하의 컴퓨터에 설치된 텍스트 파일인 쿠키를 사용하여
        사용자가 웹사이트를 어떻게 사용하는지 분석하는 데 도움을 줍니다.
        웹사이트 사용과 관련하여 쿠키로 생성된 정보(귀하의 IP 주소 포함)는
        미국에 위치한 서버를 통해 구글에 전달되어 구글에 저장됩니다. 구글은 이
        정보를 사용하여 웹사이트 사용을 평가하고 게시자의 사이트 활동에 대한
        보고서를 작성하며 웹 사이트의 활동 및 인터넷 사용과 관련된 기타 서비스를
        제공합니다. 구글은 법적 의무가 있거나 특히, 제삼자가 웹사이트 게시자를
        비롯한 구글의 계정에 대해 이러한 정보를 처리하는 경우 제삼자에게 이러한
        정보를 공개할 수 있습니다. 구글은 귀하의 IP 주소를 구글이 보유한 다른
        데이터와 상호 참조하지 않습니다.
      </li>
    </ul>
    <p>
      쿠키의 설치∙운영 및 거부: 회원님이 사용하시는 웹 브라우저의 옵션을
      선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나,
      모든 쿠키의 저장을 거부할 수 있습니다.
    </p>
    <p>
      쿠키 이용을 거부하였을 경우 로그인을 비롯한 서비스 제공에 어려움이 있을 수
      있습니다.
    </p>
    <h2 id="-10-">10. 개인정보의 기술적, 관리적 보호대책</h2>
    <p>
      코드앤버터는 이용자의 개인정보를 취급함에 있어 개인정보가 분실, 도난,
      유출, 변조 또는 훼손되지 않도록 안정성 확보를 위해 다음과 같은 기술적,
      관리적 대책을 강구하고 있습니다.
    </p>
    <ol>
      <li>
        비밀번호 미저장: 비밀번호를 별도로 저장/관리하지 않습니다. 외부 인가
        서비스의 OAuth2 로그인 방식으로 위임하거나, 이메일 로그인 시에는 임시
        토큰을 발급하는 방식으로 로그인을 진행합니다.
      </li>
      <li>
        해킹 등에 대비한 기술적 대책: 코드앤버터는 웹사이트 서비스가 호스트되고
        있는 호스팅 전문 기업의 보안 서비스를 이용하고 있습니다.
      </li>
    </ol>
    <h2 id="-11-">11. 개인정보에 관한 민원서비스</h2>
    <p>
      회사는 이용자의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기
      위하여 아래와 같이 개인정보관리 책임자를 지정하고 있습니다. 이용자는
      회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을
      개인정보관리 책임자로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에
      대해 신속하게 충분한 답변을 드릴 것입니다.
    </p>
    <ol>
      <li>
        개인정보 관리책임자
        <ul>
          <li>개인정보 관리책임자 성명: 윤정훈</li>
          <li>연락처: 02-563-2351</li>
          <li>이메일: support@codenbutter.com</li>
        </ul>
      </li>
    </ol>
    <p>
      기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래의 기관에
      문의하시기 바랍니다.
    </p>
    <p>
      아래의 기관은 코드앤버터와는 별개의 기관으로서, 코드앤버터의 자체적인
      개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이
      필요하시면 문의하여 주시기 바랍니다.
    </p>
    <h3>개인정보 침해신고센터 (한국인터넷진흥원 운영)</h3>
    <ul>
      <li>소관업무 : 개인정보 침해사실 신고, 상담 신청</li>
      <li>
        홈페이지 : <a href="http://privacy.kisa.or.kr/">privacy.kisa.or.kr</a>
      </li>
      <li>전화 : (국번없이) 118</li>
      <li>
        주소 : (138-950) 서울시 송파구 중대로 135 한국인터넷진흥원
        개인정보침해신고센터
      </li>
    </ul>
    <h3>개인정보 분쟁조정위원회 (한국인터넷진흥원 운영)</h3>
    <ul>
      <li>소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)</li>
      <li>
        홈페이지 : <a href="http://privacy.kisa.or.kr/">privacy.kisa.or.kr</a>
      </li>
      <li>전화 : (국번없이) 118</li>
      <li>
        주소 : (138-950) 서울시 송파구 중대로 135 한국인터넷진흥원
        개인정보침해신고센터
      </li>
    </ul>
    <h3>대검찰청 사이버범죄수사단</h3>
    <ul>
      <li>
        홈페이지 : <a href="http://www.spo.go.kr/">www.spo.go.kr</a>
      </li>
      <li>전화 : 02-3480-3573</li>
    </ul>
    <h3>경찰청 사이버범죄수사단</h3>
    <ul>
      <li>
        홈페이지 : <a href="http://www.netan.go.kr/">www.netan.go.kr</a>
      </li>
      <li>전화 : 1566-0112</li>
    </ul>
    <h2 id="-12-">12. 부칙</h2>
    <p>
      이 개인정보처리방침은 2024년 3월 7일부터 적용되며, 법령, 정책 또는 보안
      기술의 변경에 따라 내용의 추가, 삭제 및 수정이 있을 시에는 변경사항
      시행일의 7일 전부터 코드앤버터 웹사이트에 고지할 것입니다.
    </p>
  </>
);

export default PrivacyPolicy;
